import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TeamPage from './pages/TeamPage';
import FAQPage from './pages/FAQPage';
import SubmitCVPage from './pages/SubmitCVPage';
import ResourcesPage from './pages/ResourcesPage';
import PoliciesPage from './pages/PoliciesPage';
import FormationsPage from './pages/FormationsPage';
import RecrutementPage from './pages/RecrutementPage';
import AboutPage from './pages/AboutPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/equipe" element={<TeamPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/soumettre-cv" element={<SubmitCVPage />} />
            <Route path="/ressources" element={<ResourcesPage />} />
            <Route path="/politiques" element={<PoliciesPage />} />
            <Route path="/formations" element={<FormationsPage />} />
            <Route path="/recrutement" element={<RecrutementPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;